// src/lib/avatarUtils.ts

/**
 * Ricava le iniziali (max 2 lettere) da un nome completo.
 * Es. "Marco Rinaudi" -> "MR", "Edoardo" -> "ED".
 * Usato per gli avatar a iniziali (stile Gmail), che sostituiscono le foto profilo.
 */
export const getInitials = (name?: string | null): string => {
    if (!name) return '?';
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const AVATAR_IDS = [
    '001', '002', '003', '004', '005', '006',
    '007', '008', '009', '010', '011'
];

/**
 * Converte un ID avatar (numero, stringa, null) in un percorso file valido.
 */
export const getAvatarPath = (avatarId: string | number | null | undefined): string => {
    // 1. Se è null, undefined o vuoto -> Ritorna default
    if (avatarId === null || avatarId === undefined || avatarId === '') {
        return '/avatars/avatar-001.webp';
    }

    // 2. CONVERSIONE FORZATA IN STRINGA
    // Questo risolve l'errore "startsWith is not a function" se dal DB arriva un numero
    const strId = String(avatarId).trim();

    // 3. Se è un URL esterno (vecchio sistema), ritorna l'URL
    if (strId.startsWith('http')) {
        return strId;
    }

    // 4. Gestione padding: se dal DB arriva "1", lo trasformiamo in "001"
    // per matchare i nomi dei file. Se è già "001" o "010", non fa nulla.
    // Controlliamo se è un numero e se è corto.
    let finalId = strId;
    if (!isNaN(Number(strId)) && strId.length < 3) {
        finalId = strId.padStart(3, '0');
    }

    return `/avatars/avatar-${finalId}.webp`;
};